import React from 'react';
import ReactDOM from 'react-dom';
import './styles/styles.css';
import App from './App';
import { unregister } from './registerServiceWorker';
import {applyMiddleware, createStore} from 'redux';
import {Provider} from 'react-redux';
import website from './redux/reducers';
import thunkMiddleware from 'redux-thunk';
import {MuiThemeProvider} from '@material-ui/core/styles';
import theme from "./styles/theme";

export const store = createStore(
  website,
  applyMiddleware(
    thunkMiddleware
  )
);

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <App/>
    </MuiThemeProvider>
  </Provider>
  ,
  document.getElementById('root')
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js